import React, { useState } from 'react';
import { StepWelcome } from './StepWelcome';
import { StepPersonalDetails } from './StepPersonalDetails';
import { StepAboutYou } from './StepAboutYou';
import { StepHealthDetails } from './StepHealthDetails';
import { StepSuccess } from './StepSuccess';
import { ReflectExperience } from '../reflect/ReflectExperience';

export const PatientSignupFlow = ({ onBack }) => {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    firstName: 'Testy', lastName: 'Mctesterson',
    email: 'testy@realpatients.com', dateOfBirth: '1980-02-02',
    contactPreference: 'Email', phone: '(602) 315-5133',
    genderIdentities: ['Male'], ethnicGroups: ['White/Caucasian'],
    country: 'United States', state: 'Arizona', city: 'Gilbert',
    languageFluency: 'I am fluent in only English', otherLanguages: '',
    education: "Bachelor's degree (e.g. BA, BS)", income: '$0 - $24,999',
    areaType: 'Suburban',
    conditions: ['Lupus'], medications: ['Hydroxychloroquine'],
    insurance: 'Employer-sponsored', clinicalTrialExperience: 'Yes',
    agreedToTerms: true
  });

  const update = (changes) => setFormData((prev) => ({ ...prev, ...changes }));

  // Step 5: Reflect experience (post-signup)
  if (step === 5) {
    return (
      <ReflectExperience
        conditions={formData.conditions}
        firstName={formData.firstName}
        state={formData.state}
        onDone={onBack}
      />
    );
  }

  const steps = [
    <StepWelcome key={0} onNext={() => setStep(1)} />,
    <StepPersonalDetails key={1} formData={formData} onUpdate={update} onNext={() => setStep(2)} onBack={() => setStep(0)} />,
    <StepAboutYou key={2} formData={formData} onUpdate={update} onNext={() => setStep(3)} onBack={() => setStep(1)} />,
    <StepHealthDetails key={3} formData={formData} onUpdate={update} onNext={() => setStep(4)} onBack={() => setStep(2)} />,
    <StepSuccess key={4} formData={formData} onGoToReflect={() => setStep(5)} onBackToHome={onBack} />
  ];

  return steps[step] || steps[0];
};
